import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { FormGroup } from '@angular/forms';
import { addRemoveError, getControl, getFormArray } from '@shared/helpers/form.helper';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { REQUIRED_STATUS } from '@shared/constants/shared.constants';
import { getDatiBilancioGroup } from './helpers/dati-bilancio-form.helpers';
import { isEqual } from 'lodash-es';
import { MyElSocietaPartecipate } from '../../../models/interfaces/revisione.interface';
import { toNum } from '@shared/helpers/math.helper';

export const datiBilancioSocietaPartecipateRules: FormGroupRules = {
    my_CodiceFiscaleConsPartecipata: (form: FormGroup) => {
        const my_CodiceFiscaleConsPartecipataFormArray = getFormArray(getDatiBilancioGroup(form), 'my_SocietaPartecipate.my_ElSocietaPartecipate');
        const my_rilevaCodFiscSocPartecipate: string = getControl(form, 'my_rilevaCodFiscSocPartecipate').value;
        my_CodiceFiscaleConsPartecipataFormArray.controls.forEach((element: FormGroup) => {
            const codiceFiscaleConsPartecipate = getControl(element, 'my_CodiceFiscaleConsPartecipata');
            const errors = codiceFiscaleConsPartecipate.errors ? codiceFiscaleConsPartecipate.errors : {};
            const value: string = codiceFiscaleConsPartecipate.value;
            const containsAllZeros = !isNilOrEmpty(value) && value.includes('00000000000');
            const showLuhnError =
                !isNilOrEmpty(value) &&
                !containsAllZeros &&
                value.length === 11 &&
                (() => {
                    let somma = 0;
                    for (let index = 0; index < 11; index++) {
                        let somma1 = value.charCodeAt(index) - '0'.charCodeAt(0);
                        if ((index & 1) === 1) {
                            somma1 = somma1 * 2;
                            if (somma1 > 9) somma1 -= 9;
                        }
                        somma += somma1;
                    }
                    return somma % 10 !== 0;
                })();

            addRemoveError(containsAllZeros, errors, 'my_CodiceFiscaleConsPartecipata_contains', {
                message: 'Non valido',
                status: 'Codice fiscale non valido',
            });

            addRemoveError(!isNilOrEmpty(value) && value.length !== 11, errors, 'my_CodiceFiscaleConsPartecipata_length', {
                message: 'Lunghezza diversa da 11 caratteri',
                status: 'La lunghezza del codice fiscale non è corretta. Il codice fiscale deve essere lungo 11 caratteri',
            });

            addRemoveError(showLuhnError, errors, 'my_CodiceFiscaleConsPartecipata_luhn', {
                message: 'codice fiscale errato',
                status: 'Il codice fiscale è errato',
            });

            addRemoveError(!value && my_rilevaCodFiscSocPartecipate === 'S', errors, 'my_CodiceFiscaleConsPartecipata', {
                status: REQUIRED_STATUS,
            });

            codiceFiscaleConsPartecipate.setErrors(isEqual(errors, {}) ? null : errors);
        });
    },

    my_PercSpaSrlConsPartecipata: (form: FormGroup) => {
        const my_ConsPartecipataFormArray = getFormArray(getDatiBilancioGroup(form), 'my_SocietaPartecipate.my_ElSocietaPartecipate');

        my_ConsPartecipataFormArray.controls?.forEach((element: FormGroup) => {
            const my_PercSpaSrlControl = element.controls.my_PercSpaSrl;
            const values: MyElSocietaPartecipate = element.value;
            const errors = my_PercSpaSrlControl.errors ? my_PercSpaSrlControl.errors : {};
            const showRequiredError = isNilOrEmpty(values.my_PercSpaSrl) && (values.my_TipoSocietaPartec === '1' || values.my_TipoSocietaPartec === '2');

            addRemoveError(showRequiredError, errors, 'my_PercSpaSrl', {
                status: REQUIRED_STATUS,
            });

            addRemoveError(toNum(values.my_PercSpaSrl) > 100, errors, 'my_PercSpaSrl_max', {
                status: 'Il valore percentuale deve essere inferiore o uguale a 100',
            });

            my_PercSpaSrlControl.setErrors(isEqual(errors, {}) ? null : errors);
        });
    },

    my_SpecTipoSoc: (form: FormGroup) => {
        const my_ElSocietaPartecipateFormArray = getFormArray(getDatiBilancioGroup(form), 'my_SocietaPartecipate.my_ElSocietaPartecipate');
        my_ElSocietaPartecipateFormArray.controls.forEach((element: FormGroup) => {
            const specTipoSocControl = getControl(element, 'my_SpecTipoSoc');
            const my_TipoSocietaPartec: string = (element as FormGroup).value.my_TipoSocietaPartec;
            const errors = specTipoSocControl.errors ? specTipoSocControl.errors : {};
            addRemoveError(isNilOrEmpty(specTipoSocControl.value) && my_TipoSocietaPartec === '0', errors, 'my_SpecTipoSoc', {
                status: REQUIRED_STATUS,
            });
            specTipoSocControl.setErrors(isEqual(errors, {}) ? null : errors);
        });
    },
};
